const entries = new Map<string, { promise: Promise<unknown>; at: number }>();

/**
 * Collapses identical GETs fired by several components at once (or in quick succession) into one
 * network call. The promise is shared for `ttlMs`; a failed call is dropped immediately so a retry
 * hits the network again. Pass `force` to bypass the cache (e.g. an explicit refresh).
 */
export function sharedRequest<T>(
  key: string,
  request: () => Promise<T>,
  ttlMs = 5000,
  force = false,
): Promise<T> {
  const hit = entries.get(key);
  if (!force && hit && Date.now() - hit.at < ttlMs) return hit.promise as Promise<T>;
  const promise = request();
  entries.set(key, { promise, at: Date.now() });
  promise.catch(() => {
    if (entries.get(key)?.promise === promise) entries.delete(key);
  });
  return promise;
}
